import React, { useContext, useEffect, useState } from "react";
import {GalleriesFilterResponse, GalleriesFilterResponseData} from "../../Models/Models";
import { SiteContext } from "../../Contexts";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import {GalleryService} from "../../Services/GalleryService";
import {Form} from "react-bootstrap";

const GallerySelectorComponent = (props: { handleGalleryClick: (gallery: GalleriesFilterResponseData) => void; refreshTrigger: number  }) => {
    const imagesPerPage = React.useMemo(() => (window.innerHeight <= 1080 ? 4 : 8), []);
    const [galleriesData, setGalleriesData] = useState<GalleriesFilterResponse | null>(null);
    const [page, setPage] = useState(1)
    const [includeHidden, setIncludeHidden] = useState(true)
    const { currentSite }: any = useContext(SiteContext);
    const { filterGalleries } = GalleryService();

    const handleLoad = async (pageNum: number) => {
        setGalleriesData(await filterGalleries({
            websiteId: currentSite.id,
            limit: imagesPerPage,
            offset: (pageNum - 1) * imagesPerPage,
            visibility: includeHidden ? ['Public', 'Hidden'] : ['Public']
        }));
    };

    useEffect(() => {
        void handleLoad(1);
    }, [currentSite]);

    useEffect(() => {
        if (galleriesData && galleriesData.totalCount != null) {
            const maxValidOffset = Math.max(0, galleriesData.totalCount - 1);
            const currentOffset = (page - 1) * imagesPerPage;

            if (currentOffset > maxValidOffset) {
                const newPage = Math.max(1, Math.ceil(galleriesData.totalCount / imagesPerPage));
                setPage(newPage);
                void handleLoad(newPage);
            } else {
                void handleLoad(page);
            }
        }
    }, [props.refreshTrigger, includeHidden]);

    const handlePageChange = (newPageNum: number) => {
        void handleLoad(newPageNum);
        setPage(newPageNum);
    };

    return (
        <>
            <div className="row st-image-selector-grid">
                <Form.Group className="d-flex align-items-center align-self-start">
                    <Form.Label htmlFor="hideAlbumsPage" className="mb-0 me-2">
                        Zobraziť aj skryté albumy
                    </Form.Label>
                    <Form.Check
                        type="switch"
                        id="hideAlbumsPage"
                        label=""
                        checked={includeHidden}
                        onChange={() => setIncludeHidden(!includeHidden)}
                    />
                </Form.Group>

                {galleriesData == null || galleriesData?.data.length === 0 ? (
                    <div className="col-12 text-center">
                        <p>Žiadne galérie</p>
                    </div>
                ) : (
                    galleriesData?.data
                        .map(gallery => (
                            <div key={gallery.id} className="col-3 mb-4 align-content-center text-center">
                                <img
                                    src={gallery.titleImage.filePath}
                                    alt={gallery.titleImage.alt}
                                    className="img-thumbnail st-gallery-select-thumb"
                                    onClick={() => props.handleGalleryClick(gallery)}
                                />
                                <p className={"text-muted mt-2"}>{gallery.title}</p>
                            </div>
                        ))
                )}
            </div>

            {galleriesData && galleriesData.data.length > 0 &&
                <div className="mt-2">
                    <PaginationControl
                        page={page}
                        between={4}
                        total={galleriesData.totalCount}
                        limit={imagesPerPage}
                        changePage={(page) => handlePageChange(page)}
                        ellipsis={1}
                    />
                </div>
            }
        </>
    );
};

export default GallerySelectorComponent;
